import { Copy } from "react-feather";
import "./style.css";
import { useMessage } from "../../../../global-components/src";
import { useTranslation } from "react-i18next";

interface ShareProfileProps{
    user_name: string
}

const ShareProfile: React.FC<ShareProfileProps> = ({ user_name }) => {
    const { setMessage } = useMessage();
    const { t } = useTranslation();

    const copyLinkUser = () => {
        const encodedUserName = encodeURIComponent(user_name.trim());
        const link = `${window.location.origin}/@${encodedUserName}`;
        
        if (navigator.share) {
            navigator.share({
                title: `Compartilhar @${user_name}`,
                url: link,
            }).catch((error) => console.error('Erro ao compartilhar o link:', error));
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link)
                .then(() => setMessage(t("post.linkCopied"), "success"))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        } else {
            alert('Copie este link: ' + link);
        }
    };

    return (
        <>
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={copyLinkUser}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            <Copy data-feather="copy" className="icon-config-post"/>
                            {t("post.actions.shareProfile")}
                        </div> 
                    </div> 
                </span>
            </li>
        
        </>
    );
};

export default ShareProfile;
